import script from "./GameResultTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GameResultTable.vue?vue&type=script&setup=true&lang=js"

import "./GameResultTable.vue?vue&type=style&index=0&id=544fa770&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-544fa770"]])

export default __exports__